<template>
  <div>
    <modal title="Logout" id="logout-modal" :showFooter="false" direction="btt">
      <a class="ui red basic cancel button logout-cancel" v-on:click="hide"
        ><i class="remove icon"></i> {{ $i18n.t('Cancel') }}</a
      >
      <router-link to="/sso/logout?r=/" class="ui blue ok inverted button"
        ><i class="checkmark icon"></i> {{ $i18n.t('Log out this session') }}</router-link
      >
      <router-link to="/sso/logout?sessionOnly=0&r=/" class="ui green ok inverted button"
        ><i class="checkmark icon"></i> {{ $i18n.t('Log out from all sessions') }}</router-link
      >
    </modal>
  </div>
</template>
<script>
/**
 * @param Logout
 *
 * @description A menüből elérhető logout menüpont eseménykezelője
 */
import Modal from './modal/Modal'
import { mapActions } from 'vuex'
import axios from '../axiosClient'
import AuthProvider from '../lib/auth/provider'

export default {
  name: 'logout',
  components: {
    Modal,
  },
  data() {
    return {
      logoutUrl: `/logout`
    }
  },
  methods: {
    ...mapActions(['showModal', 'hideModal']),
    /**
     * @description felhasznalo kijelentkeztetese
     */
    async logout() {
      if (window.CORE.socket) {
        window.CORE.socket.emit('userLogout', {
          system: window.CORE.params.ID_SUBSYSTEM,
          userId: window.CORE.params.ID_S_USER,
        })
      } else {
        await axios().get(this.logoutUrl).catch(error => { console.error('axios error', error) })
        const authenticator = AuthProvider.getAuthenticator()
        return authenticator.logout()
      }
    },
    show() {
      this.showModal('logout-modal')
    },
    hide() {
      this.hideModal('logout-modal')
    },
  },
}
</script>
